import { useState } from 'react'
import { FormattedMessage } from 'react-intl'

import { Button } from '@gto/ui/button'
import { Typography } from '@gto/ui/typography'

import { ChangeEmailModal } from './change-email-modal'

export type EmailVerificationPendingProps = {
  email: string
  onResend: () => void
  onChangeEmail: (newEmail: string) => void
  isResending?: boolean
}

export const EmailVerificationPending = ({
  email,
  onResend,
  onChangeEmail,
  isResending = false,
}: EmailVerificationPendingProps) => {
  const [showModal, setShowModal] = useState(false)

  const handleOpenModal = () => {
    setShowModal(true)
  }

  const handleCloseModal = () => {
    setShowModal(false)
  }

  const handleSaveEmail = (newEmail: string) => {
    // Modal will call API and close itself on success
    onChangeEmail(newEmail)
  }

  return (
    <div className="flex max-w-[550px] flex-col gap-6">
      <div>
        <Typography
          color="text.secondary"
          variant="body1"
        >
          <FormattedMessage id="user.settings.email.verification.description" />
        </Typography>
        <Typography
          className="font-semibold"
          color="text.primary"
          variant="body1"
        >
          {email}
        </Typography>
      </div>

      <div className="flex flex-col items-start gap-4">
        <Button
          className="min-w-[250px]"
          color="primary"
          disabled={isResending}
          loading={isResending}
          size="large"
          variant="contained"
          onClick={onResend}
        >
          <FormattedMessage id="user.settings.email.verification.resend" />
        </Button>

        <Typography
          className="cursor-pointer font-bold"
          color="text.secondary"
          variant="h6"
          onClick={handleOpenModal}
        >
          <FormattedMessage id="user.settings.email.verification.changeEmail" />
        </Typography>
      </div>

      <div className="flex flex-col">
        <Typography
          className="font-bold"
          color="text.primary"
          variant="body1"
        >
          <FormattedMessage id="user.settings.email.verification.validity" />
        </Typography>
        <Typography
          className="font-bold"
          color="text.primary"
          variant="body1"
        >
          <FormattedMessage id="user.settings.email.verification.checkSpam" />
        </Typography>
      </div>

      <ChangeEmailModal
        currentEmail={email}
        open={showModal}
        onClose={handleCloseModal}
        onSuccess={handleSaveEmail}
      />
    </div>
  )
}
